// extracted by mini-css-extract-plugin
export default {"editor":"HtmlEditor_editor__50dMB","toolbar":"HtmlEditor_toolbar__XiYM2"};